
    // List of YouTube video URLs
    const videoZoeUrls = [
        'https://www.youtube-nocookie.com/embed/wLWQgxAnMhg', //Parc
        'https://www.youtube-nocookie.com/embed/3RO-hmAjBfo', //Piscine
        'https://www.youtube-nocookie.com/embed/DCNDIH_5qWs', //Plage
        'https://www.youtube-nocookie.com/embed/hdH8TUcs7jU', //Salle Arcade
        'https://www.youtube-nocookie.com/embed/273kbFbIHVk' //Salle Sport
    ];

    const videoHanaUrls = [
        'https://www.youtube-nocookie.com/embed/1bf2HiD7SN8',  // Parc
        'https://www.youtube-nocookie.com/embed/MJtYdeckLmM',  // piscine
        'https://www.youtube-nocookie.com/embed/PpGa5w2QgVI',  // plage
        'https://www.youtube-nocookie.com/embed/nqFuGzprXn0',  // Salle Arcade
        'https://www.youtube-nocookie.com/embed/EdnRDXJ6SZw'   // Salle de Sport
        
    ];
    
    const videoTalaUrls = [
        'https://www.youtube-nocookie.com/embed/UC9OwaA6Luo',  // Centre Commercial
        'https://www.youtube-nocookie.com/embed/3VXUZrZzKZQ',  // Cinema
        'https://www.youtube-nocookie.com/embed/n0pL9qSp_lQ',  // Festival
        'https://www.youtube-nocookie.com/embed/G_FdnlFUUMg',  // Montagne
        'https://www.youtube-nocookie.com/embed/fZCl_fDlyoU'  // Parc Aqua
        
    ];
    const videoMaxUrls = [
        'https://www.youtube-nocookie.com/embed/FQKoNv4oTE8',  // Centre Commercial
        'https://www.youtube-nocookie.com/embed/Qa81kbx2x3Q',  // Cinema
        'https://www.youtube-nocookie.com/embed/-zBV_-xdTz0',  // Festival
        'https://www.youtube-nocookie.com/embed/a7DkPJK0Y9I',  // Montagne
        'https://www.youtube-nocookie.com/embed/ke09DO-o8jI'  // AquaPark

    ];
    const videoHopeUrls = [
        'https://www.youtube-nocookie.com/embed/QU9Wiw_Uv68',  // Escalde
        'https://www.youtube-nocookie.com/embed/FjpLqUDyCBc',  // SkatePark
        'https://www.youtube-nocookie.com/embed/E0Ri_y5t-a8',  // Ville
        'https://www.youtube-nocookie.com/embed/U8qA0yFTJ3g',  // accrobanche
        'https://www.youtube-nocookie.com/embed/IBBxuGCQSGs'   // Lycee
        
    ];
    const videoLeoUrls = [
        'https://www.youtube-nocookie.com/embed/KkUnuy9w4Gs',  // Salle Escalade
        'https://www.youtube-nocookie.com/embed/dJQ6h7_05zc',  // SkatePark
        'https://www.youtube-nocookie.com/embed/yBZ2glSIzGE',  // Ville
        'https://www.youtube-nocookie.com/embed/ovR7oulxJdU',  // accrobanche
        'https://www.youtube-nocookie.com/embed/Q0hx9eIX5ME'   // Lycee
    ];

    const Names = [
        'zoe',  // Zoe
        'tala',  // Tala
        'hope',  // Hope
        'max',   // Max
        'leo', //Leo
        'hana' //Hana
    ];

    function getIterationNumber(VideosListlength) {
        // Set a reference start date to the first date of the current year

        const currentYear = new Date().getFullYear();
        startDate = `${currentYear}-01-01`; // First date of current year
    
        
        const start = new Date(startDate);
        const now = new Date();
        
        // Calculate the difference in milliseconds
        const timeDifference = now.getTime() - start.getTime();
        
        // Convert to days
        const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        
        // Calculate which one-day period we're in (starting from 0)
        const threeDayPeriod = Math.floor(daysDifference / 1);
        
        // Calculate iteration number (1-5, cycling)
        const iteration = (threeDayPeriod % VideosListlength);
        
        return iteration;
    }

    function loadTitle(name){
        CorrectName = 'Error';

        switch(name){
            case 'tala' : 
                CorrectName = 'Tala';
                break;
            case 'zoe' : 
                CorrectName = 'Zoé';
                break;
            case 'hana':
                CorrectName = 'Hana';
                break;
            case 'hope':
                CorrectName = 'Hope';
                break;
            case 'max':
                CorrectName = 'Max';
                break;
            case 'leo':
                CorrectName = 'Léo';
                break;
        }
        
        var lang = ('; '+document.cookie).split(`; frontend_lang=`).pop().split(';')[0];

        const titleContainer = document.getElementById('title-container');
        
        titleContainer.innerHTML = `${CorrectName}`;
    }

    function loadRandomVideo(name,id) {
            
        switch(name){
            case 'tala' : 
                videoUrls = videoTalaUrls;
                break;
            case 'zoe' : 
                videoUrls = videoZoeUrls;
                break;
            case 'hana':
                videoUrls = videoHanaUrls;
                break;
            case 'hope':
                videoUrls = videoHopeUrls;
                break;
            case 'max':
                videoUrls = videoMaxUrls;
                break;
            case 'leo':
                videoUrls = videoLeoUrls;
                break;
        }
        const randomIndex = id;
        selectedVideoUrl = videoUrls[randomIndex];
        // Create an iframe to embed the YouTube video
        const videoContainer = document.getElementById('video-container');
        if (videoContainer === undefined || videoContainer === null) {}
        else{

        videoContainer.innerHTML = `
            <iframe 
                width="360" 
                height="640" 
                src="${selectedVideoUrl}" 
                frameborder="0" 
                allow="autoplay; encrypted-media" 
                allowfullscreen>
            </iframe>
        `;
        }
    }
    

    // Load a random video when the page first loads
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if(!urlParams.has('name'))
    {
        const randomIndexName = Math.floor(Math.random() * Names.length);
        const selectedName = Names[randomIndexName];

        switch(selectedName){
            case 'tala' : 
                videoUrls = videoTalaUrls;
                break;
            case 'zoe' : 
                videoUrls = videoZoeUrls;
                break;
            case 'hana':
                videoUrls = videoHanaUrls;
                break;
            case 'hope':
                videoUrls = videoHopeUrls;
                break;
            case 'max':
                videoUrls = videoMaxUrls;
                break;
            case 'leo':
                videoUrls = videoLeoUrls;
                break;
        }
        //const randomIndex = Math.floor(Math.random() * videoUrls.length);
        const randomIndex = getIterationNumber(videoUrls.length);
        loadRandomVideo(selectedName,randomIndex); 
        loadTitle(selectedName);

    }
    else
    {
        if(!urlParams.has('id'))
        {
            name = urlParams.get('name');  
            switch(name){
                case 'tala' : 
                    videoUrls = videoTalaUrls;
                    break;
                case 'zoe' : 
                    videoUrls = videoZoeUrls;
                    break;
                case 'hana':
                    videoUrls = videoHanaUrls;
                    break;
                case 'hope':
                    videoUrls = videoHopeUrls;
                    break;
                case 'max':
                    videoUrls = videoMaxUrls;
                    break;
                case 'leo':
                    videoUrls = videoLeoUrls;
                    break;
            }
            //const selectedId = Math.floor(Math.random() * videoUrls.length);
            const selectedId = getIterationNumber(videoUrls.length);
            loadRandomVideo(name,selectedId); 
            loadTitle(name);
        }
        else {

            name = urlParams.get('name');   
            id = urlParams.get('id');  
            loadRandomVideo(name,id); 
            loadTitle(name);
        }

    }
